module.exports = __webpack_public_path__ + "img/checked2.75febb7d.png";